/* PFH Shop product page reviews (Judge.me). Loaded on product pages only, from theme.liquid.
   Kept out of custom.js on purpose: custom.js is included with a self-closing <script ... /> tag,
   so browsers download it but never run it (found 20 Oct 2026). */
/* PFH 19 Oct 2026: on phones, reviews show about one screen, then a "Show all reviews" button. */
(function () {
  function setup() {
    var box = document.getElementById('judgeme_product_reviews');
    if (!box || box.dataset.pfhClamp) return;
    box.dataset.pfhClamp = '1';
    /* The review app rewrites the widget's own classes, so the state lives on the section around it. */
    var host = box.closest('.shopify-section') || box.parentElement;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pfh-reviews-more';
    btn.textContent = 'Show all reviews';
    btn.addEventListener('click', function () {
      host.classList.add('pfh-reviews-open');
      btn.remove();
    });
    box.insertAdjacentElement('afterend', btn);
    var check = function () {
      var tall = box.scrollHeight > 760;
      host.classList.toggle('pfh-reviews-clamped', tall && !host.classList.contains('pfh-reviews-open'));
      btn.hidden = !tall || host.classList.contains('pfh-reviews-open');
    };
    check();
    /* The review app fills its box late and in steps, so re-check for 20 seconds. */
    var tries = 0;
    var timer = setInterval(function () { check(); if (++tries > 40) clearInterval(timer); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();

/* PFH 20 Oct 2026: Judge.me reviews (free plan).
   1. Its header shows "4.7  15 reviews" with no stars: add gold stars filled to the real average.
   2. Its dates are American (05/17/2026): show them the Australian way (17/05/2026).
      If Judge.me's date setting is ever changed to day/month, remove part 2. */
(function () {
  function fix() {
    var w = document.getElementById('judgeme_product_reviews');
    if (!w) return;
    var avg = w.querySelector('.jm-average-rating-display');
    if (avg && !avg.querySelector('.pfh-avg-stars')) {
      /* The text runs together ("5.01 review"), so take the first number with one decimal. */
      var m = (avg.textContent || '').match(/(\d\.\d)/);
      if (m) {
        var stars = document.createElement('span');
        stars.className = 'pfh-avg-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        stars.style.setProperty('--pfh-pct', Math.max(0, Math.min(100, parseFloat(m[1]) / 5 * 100)) + '%');
        var row = avg.firstElementChild || avg;
        row.insertBefore(stars, row.firstChild);
      }
    }
    var spans = w.querySelectorAll('span.jm-text');
    for (var i = 0; i < spans.length; i++) {
      var d = spans[i].textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (d && spans[i].getAttribute('data-pfh-date') !== spans[i].textContent.trim()) {
        var au = d[2] + '/' + d[1] + '/' + d[3];
        spans[i].textContent = au;
        spans[i].setAttribute('data-pfh-date', au);
      }
    }
  }
  /* Judge.me draws the widget late and redraws on each page of reviews, so watch the page and re-check. */
  var queued = false;
  function queue() { if (queued) return; queued = true; setTimeout(function () { queued = false; fix(); }, 150); }
  function start() { fix(); new MutationObserver(queue).observe(document.body, { childList: true, subtree: true }); }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
